<template>
  <!-- 55个科普示范基地 -->
  <div class="base-wrapper" :class="!isPC ? 'm-base-wrapper' : ''" :style="popInKr ? {height: '100%', overflowY: 'scroll', backgroundColor: 'rgba(0,0,0,0.5)'} : {height: 'auto'}">
    <p class="base-title" :class="popInKr ? 'in-kr-color' : ''">{{currentLang === 'en' ? 'Base list' : '科普示范基地'}}</p>
    <div class="sub-wrapper">
      <div class="base-list">
        <ul class="list-group list-group-flush" :class="popInKr ? 'in-kr-color' : ''">
          <li v-for="item of dataList" :key="item.uuid" class="list-group-item">
            <span class="base-num base-num-item" :class="popInKr ? 'in-kr-color' : ''">{{item.uuid}}</span>
            <span class="base-name" :class="popInKr ? 'in-kr-color' : ''" @click="showDetail(item)">{{item.companyName}}</span>
          </li>
        </ul>
      </div>
    </div>
    <template v-if="curritem.uuid">
      <div class="mask" :style="popInKr ? {backgroundColor: 'rgba(0,0,0,0.1)'} : {backgroundColor: 'rgba(255,255,255,0.1)'}">
        <div class="mask-info" :style="popInKr ? {backgroundColor: 'rgba(0,0,0,0.9)'} : {backgroundColor: 'rgba(255,255,255,0.9)'}">
          <span :class="popInKr ? 'in-kr-color' : ''" v-if="curritem.tel" v-text="curritem.tel"></span>
          <span v-if="curritem.pic">
            <img :src="curritem.pic">
          </span>
          <div class="info-close">
            <span @click="close">{{currentLang === 'en' ? 'Close' : '关闭'}}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Base',
  props: ['popInKr'],
  data() {
    return {
      curritem: {
        uuid: ''
      },
      dataList: []
    }
  },
  mounted() {
    this.initBase()
  },
  methods: {
    initBase() {
      let data = this.$allData[this.currentLang] || []
      this.dataList = data.filter((i) => {
        return i.showType === 'base_other'
      }).map((i) => {
        i.url = i.outerChain || ''
        i.tel = i.teamBrief || ''
        i.pic = (i.pictures && i.pictures[0]) ? (i.pictures[0].filePath || '') : ''
        return i
      })
    },
    showDetail(item) {
      if (item.url) {
        window.open(item.url)
        return
      }
      this.curritem = item
    },
    close() {
      this.curritem = { uuid: '' }
    }
  }
}
</script>

<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}
.mask .mask-info {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -20rem;
  margin-left: -30rem;
  width: 60rem;
  height: 40rem;
  padding: 4rem 0;
  text-align: center;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.8);
}
.mask .mask-info img {
  width: 20rem;
  height: 20rem;
}
.mask .mask-info .info-close {
  display: block;
  padding: 5rem 0 0 0;
  text-align: center;
}
.mask .mask-info .info-close span {
  cursor: pointer;
  padding: 0.8rem 4rem;
  border-radius: 2rem;
  font-size: 1.8rem;
  display: inline-block;
  color: #ec6000;
  border: 1px solid #ec6000;
}

.base-wrapper {
  width: 100%;
  height: 100%;
}
.base-title {
  padding-top: 6rem;
  text-align: center;
  font-size: 14px;
  font-weight: 550;
}
.sub-wrapper {
  width: 80rem;
  margin: 0 auto;
}
.in-kr-color {
  color: #ffffff;
}
.base-list {
  padding-left: 20px;
  padding-right: 20px;
}
.list-group-item {
  background: none;
}
.base-num {
  width: 10%;
  display: inline-block;
}
.base-num-item {
  font-size: 20px;
  font-weight: bold;
}
.base-name {
  width: 80%;
  display: inline-block;
  cursor: pointer;
}
.m-base-wrapper .sub-wrapper {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}
.m-base-wrapper .nav-item {
  width: 20%;
}
.m-base-wrapper .nav-item span {
  font-size: 12px;
}
.m-base-wrapper .base-num {
  width: 15%;
  font-size: 14px;
}
.m-base-wrapper .base-name {
  width: 65%;
  font-size: 14px;
}
</style>